module.exports = __webpack_public_path__ + "img/exhibition_design.406b9fb6.jpg";